import { cleanVariables, executeQuery } from "utils/services/apiServices";
import { actionTypes, DcddTotalUserDataInput, DcddTotalUserProps } from "./actionType";
import { FETCH_DCDD_TOTAL_USER } from "../graphql/query";
import { DateRangeInput } from "modules/user_management/dcdd_user/users/state/actionType";
import { OperationVariables } from "@apollo/client";

export const fetchDcddTotalUserRequest = () => ({
    type: actionTypes.FETCH_DCDD_TOTAL_USER_REQUEST
});

export const fetchDcddTotalUserSuccess = (payload: DcddTotalUserProps) => ({
    type: actionTypes.FETCH_DCDD_TOTAL_USER_SUCCESS,
    payload
});

export const fetchDcddTotalUserFail = (payload: string) => ({
    type: actionTypes.FETCH_DCDD_TOTAL_USER_FAIL,
    payload
});

export const fetchDcddTotalUser = (from_date:string | null = null, to_date:string| null = null, dzongkhag_id:string | null, category:string| null ) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchDcddTotalUserRequest());
            const response = await executeQuery(FETCH_DCDD_TOTAL_USER,{from_date, to_date, dzongkhag_id, category});
            const jsonData = response.data?.getDcddUserTotals;
            if (jsonData?.error === null) {
                dispatch(fetchDcddTotalUserSuccess(jsonData?.data));
            } else {
                dispatch(fetchDcddTotalUserFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchDcddTotalUserFail('Failed to fetch VideoCategories'));
        }
    };
};

export const fetchDcddTotalUserByFilterRequest = () => ({
    type: actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_REQUEST
});

export const fetchDcddTotalUserByFilterSuccess = (payload: DcddTotalUserProps) => ({
    type: actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_SUCCESS,
    payload
});

export const fetchDcddTotalUserByFilterFail = (payload: string) => ({
    type: actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_FAIL,
    payload
});

export const fetchDcddTotalUserByFilter = (input: DcddTotalUserDataInput) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchDcddTotalUserByFilterRequest());
             const cleanInput = cleanVariables(input);
            const response = await executeQuery(FETCH_DCDD_TOTAL_USER, cleanInput);
            const jsonData = response.data?.getDcddUserTotals;
            if (jsonData?.error === null) {
                dispatch(fetchDcddTotalUserByFilterSuccess(jsonData?.data));
            } else {
                dispatch(fetchDcddTotalUserByFilterFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchDcddTotalUserByFilterFail('Failed to fetch VideoCategories'));
        }
    };
};

//reset data

export const ResetDcddFilterData = () => ({
    type: actionTypes.RESET_DCDD_FILTER_DATA
});

export const resetDcddFiterData = () => {
    return async (dispatch:any) => {
        dispatch(ResetDcddFilterData())
    }
}

